<script>
	export let name
	import Login from "./components/Login.svelte"
	import Carousel from './components/Carousel.svelte'
	import Featurettes from './components/Featurettes.svelte'
	import NavBar from './components/NavBar.svelte'
	import Footer from './components/Footer.svelte'
	import About from './components/About.svelte'
	import What from './components/What.svelte'
	import {Router, Route, Link, navigate} from 'svelte-routing'
</script>

<style>
/*  */
.asbody {
    background: #e8cbc0;
    background: -webkit-linear-gradient(to right, #e8cbc0, #636fa4);
    background: linear-gradient(to right, #e8cbc0, #636fa4);
    min-height: 100vh;
}
</style>

<main role="main">

	<NavBar/>

	<Router>
			<Route exact path="/">
				<Carousel/>
				<Featurettes/>
			</Route>
			<Route exact path="/signin">
				<Login/>
			</Route>
			<Route exact path="/about" component={About} />
			<Route exact path="/service" component={What} />
			<!-- <Route exact path="/characters" component={PlayerCharacters} /> -->
			<!-- <Route path="/characters/:id" component="{CharacterSheet}" /> -->
	</Router>

	<Footer/>

</main>	
